import React from 'react';
import { Group } from '../../../primitives/Group/Group.es.js';
import { PaginationPageButton } from '../styled.es.js';

const PaginationButton = ({
  buttonComponent: ButtonComponent = PaginationPageButton,
  buttonSize,
  shape,
  isDisabled,
  isSelected,
  onClick,
  page,
  itemType,
  children
}) => /* @__PURE__ */ React.createElement(Group.Item, null, /* @__PURE__ */ React.createElement(PaginationPageButton, {
  as: ButtonComponent,
  onClick,
  buttonSize,
  shape,
  isDisabled,
  variant: "subtle",
  page,
  itemType,
  "aria-current": isSelected ? true : void 0
}, children));

export { PaginationButton as default };
//# sourceMappingURL=PaginationButton.es.js.map
